/** Llamadas HTTP del módulo Asambleas (TipoReunion + Reunion + Asistencia). */
import { apiDownload, apiRequest } from "../../lib/api";

export type EstadoReunion = "Programada" | "Realizada" | "Cerrada" | "Cancelada";
export type EstadoAsistencia = "Presente" | "Ausente" | "Justificado";

export interface TipoReunionRead {
  id: number;
  empresa_id: number;
  nombre: string;
  descripcion: string | null;
  created_at: string;
  updated_at: string;
}

export interface ReunionRead {
  id: number;
  empresa_id: number;
  tipo_reunion_id: number;
  fecha: string;
  hora: string;
  lugar: string | null;
  observaciones: string | null;
  estado: EstadoReunion;
  genera_multa: boolean;
  created_at: string;
  updated_at: string;
}

export interface AsistenciaRead {
  id: number;
  empresa_id: number;
  reunion_id: number;
  socio_id: number;
  estado: EstadoAsistencia;
  observacion: string | null;
  created_at: string;
  updated_at: string;
}

export interface CerrarAsistenciaResponse {
  reunion_id: number;
  estado: EstadoReunion;
  multas_generadas: number;
  monto_unitario: number;
}

export interface AsistenciaItem {
  socio_id: number;
  estado: EstadoAsistencia;
  observacion?: string | null;
}

// ── TipoReunion ──────────────────────────────────────────────────────────

export function listarTipos(): Promise<TipoReunionRead[]> {
  return apiRequest<TipoReunionRead[]>("/api/v1/tipos-reunion");
}

export function crearTipo(p: {
  nombre: string;
  descripcion?: string | null;
}): Promise<TipoReunionRead> {
  return apiRequest<TipoReunionRead>("/api/v1/tipos-reunion", {
    method: "POST",
    body: p,
  });
}

// ── Reunion ──────────────────────────────────────────────────────────────

export function listarReuniones(estado?: EstadoReunion): Promise<ReunionRead[]> {
  const qs = estado ? `?estado=${estado}` : "";
  return apiRequest<ReunionRead[]>(`/api/v1/reuniones${qs}`);
}

export function obtenerReunion(id: number): Promise<ReunionRead> {
  return apiRequest<ReunionRead>(`/api/v1/reuniones/${id}`);
}

export function crearReunion(p: {
  tipo_reunion_id: number;
  fecha: string;
  hora: string;
  lugar?: string | null;
  observaciones?: string | null;
  genera_multa?: boolean;
}): Promise<ReunionRead> {
  return apiRequest<ReunionRead>("/api/v1/reuniones", {
    method: "POST",
    body: p,
  });
}

export function cancelarReunion(id: number): Promise<ReunionRead> {
  return apiRequest<ReunionRead>(`/api/v1/reuniones/${id}/cancelar`, {
    method: "POST",
  });
}

// ── Asistencias ──────────────────────────────────────────────────────────

/** Lista de asistencia en CSV, para el libro de actas. */
export function exportarAsistenciaCsv(reunionId: number): Promise<void> {
  return apiDownload(
    `/api/v1/reuniones/${reunionId}/asistencias/export.csv`,
    `asistencia_reunion_${reunionId}.csv`,
  );
}

export function listarAsistencias(reunionId: number): Promise<AsistenciaRead[]> {
  return apiRequest<AsistenciaRead[]>(
    `/api/v1/reuniones/${reunionId}/asistencias`,
  );
}

export function cargarAsistencias(
  reunionId: number,
  items: AsistenciaItem[],
): Promise<AsistenciaRead[]> {
  return apiRequest<AsistenciaRead[]>(
    `/api/v1/reuniones/${reunionId}/asistencias`,
    { method: "POST", body: { items } },
  );
}

export function cerrarReunion(
  reunionId: number,
): Promise<CerrarAsistenciaResponse> {
  return apiRequest<CerrarAsistenciaResponse>(
    `/api/v1/reuniones/${reunionId}/cerrar`,
    { method: "POST" },
  );
}
